import React, { useState } from "react"
import { ChevronIcon, InfoIcon, XmarkIcon } from "../Icons/small"

export const AnnouncementFlag = ({
  announcement_text,
  announcement_title,
  severity = "info",
  show_flag,
  close_flag,
  windowWidth,
  default_expanded = false,
}) => {
  const color_mapping = {
    info: {
      bg_color: "mitternachtsblau",
      txt_color: "white",
      icon: InfoIcon,
      icon_color: "#fff",
    },
    warning: {
      bg_color: "sonnengelb",
      txt_color: "mitternachtsblau",
      icon: InfoIcon,
      icon_color: "#034055",
    },
    danger: {
      bg_color: "danger",
      txt_color: "white",
      icon: InfoIcon,
      icon_color: "#fff",
    },
  }

  const [mobile_flag_expanded, set_mobile_flag_expanded] =
    useState(default_expanded)
  const toggle_mobile_flag_expanded = (e) => {
    e.preventDefault()
    set_mobile_flag_expanded(!mobile_flag_expanded)
  }

  return (
    <React.Fragment>
      <div
        style={{
          transition: ".2s ease",
          position: "fixed",
          bottom:
            windowWidth <= 1023 ? (show_flag ? 55 : -505) : show_flag ? 0 : -86,
          width: windowWidth > 1023 ? "100%" : "94.5%",
          marginLeft: windowWidth > 1023 ? undefined : "2.75%",
          zIndex: 99,
        }}
        className={`has-background-${color_mapping[severity]?.bg_color} has-box-shadow-strong`}
      >
        <div
          className="container is-flex is-justify-content-space-between"
          style={{
            minHeight: windowWidth > 1023 ? 86 : 62,
          }}
        >
          <div className="my-auto mx-3">
            <div className="is-flex">
              <p
                className={`title is-4 my-3 has-text-${color_mapping[severity].txt_color}`}
                style={{ minWidth: 116 }}
              >
                {announcement_title}
              </p>
              <div className="is-hidden-desktop my-auto ml-auto">
                {mobile_flag_expanded ? (
                  <a href=" #" onClick={close_flag} className="my-auto mx-3">
                    <XmarkIcon
                      {...{
                        color: color_mapping[severity].icon_color,
                        size: 0.5,
                        strokeWidth: 6,
                      }}
                    />
                  </a>
                ) : (
                  <a
                    href=" #"
                    onClick={toggle_mobile_flag_expanded}
                    className="my-auto mx-3"
                  >
                    <ChevronIcon
                      {...{
                        color: color_mapping[severity].icon_color,
                        size: 0.8,
                        stroke_width: 5,
                        rotation: "up",
                      }}
                    />
                  </a>
                )}
              </div>
            </div>
            <div
              className="is-hidden-desktop"
              style={{
                transition: ".3s ease",
                maxHeight: mobile_flag_expanded ? 500 : 0,
                paddingTop: mobile_flag_expanded ? 15 : 0,
                paddingBottom: mobile_flag_expanded ? 20 : 0,
                overflow: "hidden",
              }}
            >
              <p className={`has-text-${color_mapping[severity].txt_color}`}>
                {announcement_text}
              </p>
            </div>
          </div>
          <p
            className={`my-auto is-hidden-touch has-text-${color_mapping[severity].txt_color}`}
            style={{
              textOverflow: "ellipsis",
              WebkitLineClamp: "1",
              whiteSpace: "nowrap",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              overflow: "hidden",
              paddingBottom: 3,
            }}
          >
            {announcement_text}
          </p>
          <a
            href=" #"
            onClick={close_flag}
            className="my-auto mx-3 is-hidden-touch"
          >
            <XmarkIcon
              {...{
                color: color_mapping[severity].icon_color,
                size: 0.5,
                strokeWidth: 6,
              }}
            />
          </a>
        </div>
      </div>
    </React.Fragment>
  )
}
